import { Divider } from 'antd';
import { useContext, type JSX } from 'react';
import { useLocation } from 'react-router';

import { AccessibilityPanelButton } from '@/widgets/Layout';

import { GovUaLogo, OrderServiceLink } from '@/features/ui';

import { ButtonVariant, Icon, Link, LinkAsButton, Typography } from '@/shared/ui';

import { ROUTES } from '@/router/config';

import AuthContext from '@/contexts/Auth/AuthContext';

import { MVSButton } from './MVSButton';
import { NavTabs } from './NavTabs';

import './HeaderBannerStyles.scss';

export const Header = (): JSX.Element => {
  const { isLoggedIn } = useContext(AuthContext);
  const { pathname } = useLocation();

  return (
    <div className="header-banner">
      <div className="container">
        <div className="header-banner__content">
          <div className="header-banner__links">
            <div className="header-banner__links-container">
              <Link to={ROUTES.HOME} className="header-banner__logo">
                <Icon name="evg_logo" color="white" width={150} height={50} />
              </Link>
              <div className="header-banner__links-container header-banner__links-container--external">
                <GovUaLogo />
                <Divider type="vertical" className="header-banner__links-container-divider" />
                <MVSButton />
              </div>
            </div>

            <NavTabs />
          </div>
          <div className="header-banner__action-buttons">
            <div className="header-banner__action-buttons-auth">
              <AccessibilityPanelButton />
              {!isLoggedIn && (
                <LinkAsButton
                  className="header-banner__btn"
                  to={ROUTES.LOGIN}
                  variant={ButtonVariant.ICON_GHOST}
                  state={{
                    nextPage: pathname,
                  }}
                >
                  <Icon name="account" width={24} height={24} />
                  <Typography as="span">Увійти</Typography>
                </LinkAsButton>
              )}
              {isLoggedIn && (
                <>
                  <LinkAsButton
                    to={ROUTES.USER.PROFILE}
                    variant={ButtonVariant.ICON_GHOST}
                    className="header-banner__btn"
                  >
                    <Icon name="account" width={24} height={24} />
                    <Typography as="span">Особистий кабінет</Typography>
                  </LinkAsButton>
                </>
              )}
            </div>

            <OrderServiceLink />
          </div>
        </div>
      </div>
    </div>
  );
};
